export default "__VITE_ASSET__DAxiUdmz__"